import * as React from 'react';

import { get as userGet } from 'js/lib/user';

import type { ConsumerPageHeader_EnterpriseProgramFragment as EnterpriseProgramFragment } from 'bundles/composable-page-header-consumer/queries/__generated__/ConsumerMyPageHeaderQuery';
import EnterpriseSearchBarV2, {
  UnifiedEnterpriseSearchBar,
} from 'bundles/enterprise-learner-search/components/search/EnterpriseSearchBarV2';
import { useEnterpriseProductFeatures } from 'bundles/unified-common/contexts/EnterpriseProductFeaturesContext';

type Props = {
  currentProgram?: Partial<EnterpriseProgramFragment> | null;
};

export function EnterpriseSearchBarLegacyGridItem(props: Props) {
  const { currentProgram } = props;
  const enterpriseProductFeatures = useEnterpriseProductFeatures();
  const userId = userGet()?.id;

  const enableSkillsInSearchAndBrowse = enterpriseProductFeatures?.enableSkillsInSearchAndBrowse;
  const shouldShowShortFormContent = enterpriseProductFeatures?.allowShortFormContentBasedOnAudience;

  const thirdPartyOrganizationSlug = currentProgram?.naptimeThirdPartyOrganization?.slug;
  const thirdPartyOrganizationId = currentProgram?.naptimeThirdPartyOrganization?.id;

  const programSlug = currentProgram?.slug;
  const programName = currentProgram?.name;
  const programId = currentProgram?.id;

  if (userId && programSlug && programName && programId && thirdPartyOrganizationId && thirdPartyOrganizationSlug) {
    return (
      <UnifiedEnterpriseSearchBar
        programSlug={programSlug}
        programName={programName}
        thirdPartyOrgSlug={thirdPartyOrganizationSlug}
        thirdPartyOrganizationId={thirdPartyOrganizationId}
        userId={userId}
        programId={programId}
        enableSkillsInSearchAndBrowse={enableSkillsInSearchAndBrowse}
        shouldShowShortFormContent={shouldShowShortFormContent}
      />
    );
  } else if (programId) {
    return (
      <EnterpriseSearchBarV2
        programIds={[programId]}
        enableSkillsInSearchAndBrowse={enableSkillsInSearchAndBrowse ?? false}
        shouldShowShortFormContent={shouldShowShortFormContent}
        programName={programName}
      />
    );
  } else {
    return null;
  }
}

export default EnterpriseSearchBarLegacyGridItem;
